/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { ISnackbarData } from "@/components/md/MdSnackbar";

export interface IRootState {
  initialized: boolean;
  root: boolean;
  sidenavRail: boolean;
  snackbar: ISnackbarData | null;
  showLoader: boolean;
  variablePicker: {
    open: boolean;
    anchor: HTMLElement | null;
    target: HTMLInputElement | null;
    variable: string | null;
  }
}

export const state: IRootState = {
  initialized: false,
  root: true,
  sidenavRail: false,
  snackbar: null,
  showLoader: true,
  variablePicker: {
    open: false,
    anchor: null,
    target: null,
    variable: null
  }
};